import React, { useState, useEffect } from 'react'; // Import useState and useEffect
import { ClipboardList, Pencil } from 'lucide-react'; // Import icons, removed EllipsisVertical and Trash2

const MyTasksTable = ({ myTasks, loadingMyTasks, onEditTask }) => { // Removed onDeleteTask from props

  return (
    <div className="bg-white/80 backdrop-blur-md border border-blue-200 rounded-2xl p-6 shadow-md flex flex-col">
      <h2 className="text-xl font-semibold text-slate-800 mb-6 flex items-center">
        <ClipboardList className="mr-3 text-blue-500" size={24} />
        My Tasks
      </h2>
      {loadingMyTasks ? (
        <div className="text-center text-slate-600">Loading tasks...</div>
      ) : myTasks.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-blue-200">
            <thead className="bg-blue-50">
              <tr>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                  Project
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                  Equipment
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                  Task Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                  Task Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                  Contribution (%)
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-blue-100">
              {myTasks.map((task) => (
                <tr key={task.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                    {task.project_name || 'N/A'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600">
                    {task.ship_name || 'N/A'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600">
                    {task.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600">
                    {task.task_type || 'N/A'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600">
                    {typeof task.contribution_calc === 'number' ? `${task.contribution_calc.toFixed(1)}%` : 'N/A'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    {/* Directly display the Edit icon */}
                    <button
                      type="button"
                      className="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100 transition-colors"
                      onClick={() => onEditTask(task)}
                      title="Edit task"
                    >
                      <Pencil className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center text-slate-600 p-8">No tasks found.</div>
      )}
    </div>
  );
};

export default MyTasksTable;